/**
 * Central registry of feature toggle keys used across the application.
 *
 * These are consumed through `FeatureToggleClientService` from any module
 * (shell, addlink, emtr). The service is backed by LaunchDarkly today, but
 * consumers depend only on this vendor-neutral registry.
 *
 * Adding a new toggle is a low-touch change: register its key here and a
 * sensible default in `featureToggleDefaults`.
 */
export const featureFlags = {
  maintenanceMode: 'strp.web.ops.maintenance-mode',
  restrictionSimulator: 'strp.web.ops.restriction-simulator'
} as const;

/**
 * Default toggle values used before the feature toggle connection is ready or
 * when the connection cannot be established. Keys must match the keys above.
 */
export const featureToggleDefaults: { [flagKey: string]: boolean | string | number } = {
  [featureFlags.maintenanceMode]: false,
  [featureFlags.restrictionSimulator]: false
};
